import {
  faBacon, faBeer,
  faBreadSlice,
  faCarrot, faCheese, faCookieBite,
  faDrumstickBite, faEgg, faGlassWhiskey,
  faIceCream, faPepperHot, faPrescriptionBottle,
  faTemperatureLow, faToiletPaper
} from '@fortawesome/free-solid-svg-icons';
import {IconDefinition} from '@fortawesome/fontawesome-svg-core';

export interface ItemCategory {
  name: string;
  shopOrder: number;
  icon: IconDefinition;
  backgroundColor: string;
}

const categories: ItemCategory[] = [
  {name: 'Groente', shopOrder: 1, icon: faCarrot, backgroundColor: '#344035'},
  {name: 'Vlees', shopOrder: 2, icon: faDrumstickBite, backgroundColor: '#402b29'},
  {name: 'Vleeswaren', shopOrder: 3, icon: faBacon, backgroundColor: '#403037'},
  {name: 'Zuivel', shopOrder: 4, icon: faCheese, backgroundColor: '#3e402d'},
  {name: 'Brood', shopOrder: 5, icon: faBreadSlice, backgroundColor: '#403d2a'},
  {name: 'Eten', shopOrder: 6, icon: faPepperHot, backgroundColor: '#402c29'},
  {name: 'Conserven', shopOrder: 7, icon: faPrescriptionBottle, backgroundColor: '#3f3d40'},
  {name: 'Huishouden', shopOrder: 8, icon: faToiletPaper, backgroundColor: '#2a3840'},
  {name: 'Dranken', shopOrder: 9, icon: faGlassWhiskey, backgroundColor: '#3f403e'},
  {name: 'Snacks', shopOrder: 10, icon: faBeer, backgroundColor: '#40402e'},
  {name: 'Diepvries', shopOrder: 11, icon: faIceCream, backgroundColor: '#283340'},
  {name: 'Overig', shopOrder: 12, icon: faCookieBite, backgroundColor: '#402f40'},
].sort((cat1, cat2) => cat1.shopOrder - cat2.shopOrder);

const categoryMap = categories.reduce((map, obj) => {
  map[obj.name] = obj;
  return map;
}, {});

const overig = categoryMap['Overig'];
export {categoryMap, categories, overig};
